import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';

export default mergeStyleSets({
  transparentBackground: {
    backgroundColor: 'transparent',
  },
  detailsList: {
    backgroundColor: 'transparent',
  },
  rightAlignHeader: {
    backgroundColor: 'transparent',
    '& span > span': {
      justifyContent: 'flex-end',
      paddingRight: '32px',
    },
  },
  rightAlignText: {
    textAlign: 'right',
    width: '100%',
    display: 'inline-block',
  },
  red: {
    color: theme.palette.red,
  },
});
